import { defineComponent as _defineComponent } from 'vue'
import NewPlant from "@/components/plant/NewPlant.vue"

const __default__ = {
  name: "NewPlantPage"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {
  expose();



const __returned__ = { NewPlant }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})